export type LocalizationTargetLocale = 'esCO' | 'esAR' | 'esMX' | 'esPE' | 'esCAC'  | 'ptBR';

export type LocalizationRunStatus =
  | 'queued'
  | 'processing'
  | 'awaiting_selection'
  | 'awaiting_review'
  | 'approved'
  | 'queued_apply'
  | 'applying'
  | 'completed'
  | 'failed'
  | 'cancelled';

export type LocalizationItemStatus =
  | 'pending'
  | 'processing'
  | 'selection-required'
  | 'preview-generated'
  | 'applied'
  | 'not-found'
  | 'invalid'
  | 'already-localized'
  | 'failed';

export interface LocalizationRunItem {
  sku: string;
  indexadoSourceQuery?: string;
  status: LocalizationItemStatus;
  modelId?: string | null;
  localizableFields?: number;
  changedFields?: number;
  reviewRequired?: boolean;
  candidates?: Array<{
    modelId: string;
    artifact: string;
  }>;
  error?: string;
  artifacts?: {
    original: string;
    localized: string;
    comparison: string;
    rejectedTranslations?: string;
    indexadoOriginal?: string;
    indexadoLocalized?: string;
    indexadoComparison?: string;
  };
  localizations?: Partial<Record<LocalizationTargetLocale, LocalizationLocaleResult>>;
}

export interface LocalizationLocaleResult {
  targetLocale: LocalizationTargetLocale;
  status: LocalizationItemStatus;
  modelAlreadyLocalized?: boolean;
  indexadoAlreadyLocalized?: boolean;
  indexadoPartiallyLocalized?: boolean;
  indexadoNotFound?: boolean;
  sourceIndexadoId?: string;
  indexadoSourceLocale?: string;
  indexadoVersion?: 'V4' | 'V5';
  localizableFields?: number;
  changedFields?: number;
  error?: string;
  artifacts?: {
    original: string;
    localized: string;
    comparison: string;
    rejectedTranslations?: string;
    indexadoOriginal?: string;
    indexadoLocalized?: string;
    indexadoComparison?: string;
  };
}

export interface LocalizationRun {
  runId: string;
  ownerId: string;
  sourceLocale: string;
  targetLocale?: LocalizationTargetLocale;
  targetLocales: LocalizationTargetLocale[];
  provider: 'openai';
  force: boolean;
  replaceDefaultIndexado?: boolean;
  additionalFields: string[];
  status: LocalizationRunStatus;
  skus: string[];
  progress: {
    total: number;
    completed: number;
    succeeded: number;
    failed: number;
    percentage: number;
    currentSku?: string;
  };
  items: LocalizationRunItem[];
  approvedBy?: string;
  approvedAt?: string;
  applyQueuedAt?: string;
  createdAt: string;
  startedAt?: string;
  finishedAt?: string;
  error?: string;
}

export interface CreateLocalizationRunRequest {
  skus: string[];
  sourceLocale: string;
  targetLocales: LocalizationTargetLocale[];
  provider: 'openai';
  force: boolean;
  replaceDefaultIndexado?: boolean;
  additionalFields: string[];
}

export interface LocalizationConfig {
  directLocalizableFields: string[];
  maxAdditionalFields: number;
  maxTextLocalizationUnitsPerRun: number;
  maxExcelLocalizationUnitsPerRun: number;
}

export interface CreateLocalizationRunResponse {
  runId: string;
  status: LocalizationRunStatus;
  statusUrl?: string;
  eventsUrl?: string;
}

export interface ExcelLocalizationOptions {
  sourceLocale: string;
  targetLocales: LocalizationTargetLocale[];
  force: boolean;
  replaceDefaultIndexado?: boolean;
  additionalFields: string[];
}

export type LocalizationArtifactKind =
  | 'final'
  | 'original'
  | 'localized'
  | 'comparison'
  | 'rejectedTranslations'
  | 'indexadoOriginal'
  | 'indexadoLocalized'
  | 'indexadoComparison';
export type LocalizationSseStatus = 'disconnected' | 'connecting' | 'connected' | 'error';

export const ACTIVE_LOCALIZATION_STATUSES: LocalizationRunStatus[] = [
  'queued',
  'processing',
  'queued_apply',
  'applying',
];
